import React from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path ? "nav-link active" : "nav-link";

  const handleNavLinkClick = () => {
    const navbar = document.getElementById("mainNavbar");
    if (navbar && navbar.classList.contains("show")) {
      const collapse = window.bootstrap.Collapse.getInstance(navbar);
      if (collapse) {
        collapse.hide();
      }
    }
  };

  return (
    <header className="main-header bg-section">
      <div className="header-sticky">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <div className="container">
            <Link className="navbar-brand logo-web" to="/">
               <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Logo" />
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNavbar"
              aria-controls="mainNavbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse main-menu" id="mainNavbar">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link
                    className={isActive("/")}
                    to="/"
                    onClick={handleNavLinkClick}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/how-it-works")}
                    to="/how-it-works"
                    onClick={handleNavLinkClick}
                  >
                    How it works
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/blogs")}
                    to="/blogs"
                    onClick={handleNavLinkClick}
                  >
                    Blogs
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/faqs")}
                    to="/faqs"
                    onClick={handleNavLinkClick}
                  >
                    FAQs
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/about-us")}
                    to="/about-us"
                    onClick={handleNavLinkClick}
                  >
                    About IngredientIQ™
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/app")}
                    to="/app"
                    onClick={handleNavLinkClick}
                  >
                    The App
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={isActive("/contact-us")}
                    to="/contact-us"
                    onClick={handleNavLinkClick}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
